const state = {
    source: null
}

const getters = {
    getSource: state => state.source,
}

const mutations = {
    setSource(state, source) {
        state.source = source
    }
}

const actions = {
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/source.js